// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"flight-landing"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M10.2802 2.5L12.212 3.01764L14.7779 11.9874L20.2837 13.4626C21.0839 13.6771 21.5587 14.4996 21.3443 15.2998C21.1299 16.1 20.3074 16.5748 19.5072 16.3604L2.60352 11.8311L2.93169 6.74264L4.38057 7.13087L5.02205 9.3733L10.1415 10.745L10.2802 2.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M10.2802 2.5L12.212 3.01764L14.7779 11.9874L20.2837 13.4626C21.0839 13.6771 21.5587 14.4996 21.3443 15.2998C21.1299 16.1 20.3074 16.5748 19.5072 16.3604L2.60352 11.8311L2.93169 6.74264L4.38057 7.13087L5.02205 9.3733L10.1415 10.745L10.2802 2.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M3 20H21","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-flight-landing')
export default class FlightLandingIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'flight-landing',
    }
  }
}
